export default {"src":"/_next/static/media/cnd.db92293f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};